/* eslint-disable import/prefer-default-export */
export const areEqual = (object1, object2) => JSON.stringify(object1) === JSON.stringify(object2);
